<template>
  <VDialog v-model="isShowModal" max-width="600" persistent>
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-plus" class="mr-2" />
        No-Bid
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VForm v-model="formValid" @submit.prevent class="mb-3 my-2">
          <VRow>
            <VCol cols="12">
              <div class="my-2 mx-2">
                <VSelect
                  :items="noBidOptions"
                  item-title="name"
                  label="No-Bid Reason"
                  variant="outlined"
                  v-model="form.value"
                  placeholder="Select Reason"
                  :rules="formRules.value"
                  :disabled="isLoading"
                >
                  <template v-slot:item="{ props: itemProps, item }">
                    <VListItem v-bind="itemProps" :subtitle="item.raw.type"></VListItem>
                  </template>
                </VSelect>
              </div>
            </VCol>
            <VCol v-if="form.value === 'Other (with comment)'" cols="12">
              <div class="my-2 mx-2">
                <VTextarea
                  label="Comment"
                  v-model="form.comment"
                  variant="outlined"
                  placeholder="Enter Comment"
                  prepend-inner-icon="mdi-text"
                  :disabled="isLoading"
                  :rules="formRules.comment"
                  :maxlength="255"
                ></VTextarea>
              </div>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="primary" block flat @click="handleSubmit()">
                Sent
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import invitesService from '@/services/invites-service/invites.service';
// Text
import { successNoBidSubmitInviteText, errorNoBidSubmitInviteText } from '@/text/snackbarsText';
export default {
  name: 'SubmitNoBidInviteModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    inviteId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'saved'],

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  data() {
    return {
      isLoading: false,
      noBidOptions: [
        {
          name: 'Requirements outside current service capabilities',
          type: 'Scope / Technical'
        },
        {
          name: 'Technical solution not supported',
          type: 'Scope / Technical'
        },
        {
          name: 'Capacity or coverage limitations',
          type: 'Scope / Technical'
        },
        {
          name: 'Delivery timeline not achievable',
          type: 'Scope / Technical'
        },
        //
        {
          name: 'Pricing not commercially viable',
          type: 'Commercial / Financial'
        },
        {
          name: 'Minimum deal size not met',
          type: 'Commercial / Financial'
        },
        //
        {
          name: 'Opportunity not aligned with current strategy',
          type: 'Strategic / Business'
        },
        {
          name: 'Low strategic priority',
          type: 'Strategic / Business'
        },
        {
          name: 'Existing contractual commitments',
          type: 'Strategic / Business'
        },
        {
          name: 'Conflict with existing customer engagements',
          type: 'Strategic / Business'
        },
        //
        {
          name: 'Insufficient resources to respond',
          type: 'Operational / Resource'
        },
        {
          name: 'Current workload constraints',
          type: 'Operational / Resource'
        },
        {
          name: 'Internal approval not granted',
          type: 'Operational / Resource'
        },
        //
        {
          name: 'Insufficient time to respond',
          type: 'Process / Timing'
        },
        {
          name: 'RFP timeline too aggressive',
          type: 'Process / Timing'
        },
        {
          name: 'Incomplete or unclear requirements',
          type: 'Process / Timing'
        },
        //
        {
          name: 'Regulatory or compliance concerns',
          type: 'Risk / Compliance'
        },
        {
          name: 'Risk profile not acceptable',
          type: 'Risk / Compliance'
        },
        {
          name: 'Legal or contractual constraints',
          type: 'Risk / Compliance'
        },
        //
        {
          name: 'Duplicate or withdrawn RFP',
          type: 'Other'
        },
        {
          name: 'Other (with comment)',
          type: 'Other'
        }
      ],
      form: {
        value: '',
        comment: ''
      },
      formRules: {
        value: [(v) => !!v || 'No-Bid Reason required'],
        comment: [(v) => (!!v && this.form.value === 'Other (with comment)') || 'Comment required']
      },
      formValid: false
    };
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleSubmit() {
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          const payload = {
            inviteId: this.inviteId,
            noBidReason: this.form.value === 'Other (with comment)' ? this.form.comment : this.form.value,
            isNoBid: true
          };
          await invitesService.submitInvite(payload);
          this.showSnackbar({ text: successNoBidSubmitInviteText, color: 'green' });
          this.handleSuccess();
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorNoBidSubmitInviteText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },

    handleSuccess() {
      this.$emit('saved');
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.resetForm();
    },

    resetForm() {
      this.form = {
        value: '',
        comment: ''
      };
    }
  }
};
</script>
